import script from "./LoaderSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=c57e7bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57e7bc0"]])

export default __exports__